import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TrackRecord } from '../components/TrackRecord';
import { CapitalLifecycle } from '../components/CapitalLifecycle';
import { CitiesSection } from '../components/CitiesSection';
import { OurApproach } from '../components/OurApproach';
import { IndustriesExpertise } from '../components/IndustriesExpertise';
import { CaseStudies } from '../components/CaseStudies';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { InsightsSection } from '../components/InsightsSection';
import { AboutUs } from '../components/AboutUs';
import { FAQ } from '../components/FAQ';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <WhatsAppButton />
      <Hero />
      <TrackRecord />
      <CapitalLifecycle />
      <OurApproach />
      <IndustriesExpertise />
      <CitiesSection />
      <CaseStudies />
      <WhyChooseUs />
      <InsightsSection />
      <AboutUs />
      <FAQ />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;
